<template>
  <div class="bg-white rounded shadow-sm py-3 my-2">
    <form @submit.prevent="set_sms_wallet" id="settings_sms_wallet_form">
      <div class="d-flex align-items-center px-3">
        <div class="mr-auto d-flex align-items-center h5">
          <i class="fas fa-wallet text-primary"></i>
          <div class="mx-2">{{ $t("notification.label.sms_wallet_title") }}</div>
        </div>
        <div>
          <span>{{ $t("notification.label.sms_count_can_be_send") }}</span>&nbsp;
          <span>{{ form_data.sms_count_can_send }}</span>
        </div>
      </div>
      <hr />
      <div class="p-3">
        <div class="d-flex align-items-center">
          <div class="form-group w-50 px-3">
            <label for="sms_charge">{{ $t("notification.label.recharge_sms_wallet") }}</label>
            <input
              type="number"
              id="sms_charge"
              class="form-control"
              v-model="sms_number"
              placeholder="تعداد پیامک"
              @keyup="setRechargePrice()"
              @change="setRechargePrice()"
            />
            <small class="form-text text-muted"
              >{{ $t("notification.label.minimum_price_for_recharge") }}</small
            >
          </div>
          <input
            name="recharge_price"
            type="number"
            :value="recharge_price"
            style="display: none"
            id="recharge_price"
          />
          <div class="ml-auto">
            <span class="text-success px-2"
              >{{ $t("notification.label.recharge_price") }}
              <span>
                {{ recharge_price_currency_format + " " + $t("label.rial") }}
              </span>
            </span>
            <button
              type="submit"
              class="btn btn-success"
              id="submit_btn_sms_wallet">
              <span>{{ $t("notification.label.pay") }}</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {i18n} from "@/plugins/i18n";

export default {
  name: "smsWallet",
  props: {
    set_sms_wallet: {
      default: () => {},
      type: Function,
    },
    form_data: {
      default() {
        return {};
      },
      type: Object,
    },
  },
  data() {
    return {
      sms_number: 0,
      recharge_price: 0,
      recharge_price_currency_format: 0,
    };
  },
  computed: {
    ...mapGetters("notificationSms", ["getRechargePriceStatus"]),
  },
  methods: {
    increment() {
      this.$store.dispatch("notificationSms/increment");
    },
    setRechargePrice() {
      this.recharge_price = this.sms_number * this.form_data.sms_price;
      this.recharge_price_currency_format = this.moneyFormat(
        this.recharge_price
      );
    },
    moneyFormat(price) {
      const pieces = parseFloat(price).toFixed(0).split("");
      let ii = pieces.length;
      while ((ii -= 3) > 0) {
        pieces.splice(ii, 0, ",");
      }
      return pieces.join("");
    },
  },
};
</script>
<style scoped>

</style>